import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { useFieldArray } from 'react-hook-form';

import { SelectButton } from '../../../../../components/StyledButton';
import { useFormItems } from '../../../../../hooks/formItems';
import { MatterSummary } from '../../../../../models/gen/matterSummary';
import { Formatter } from '../../../../../utils/FormatUtils';
import { useSizeContext } from '../../../../SizeProvider';

/**
 * 検索結果プロパティ
 */
type ResultProps = {
  /**
   * 現場選択イベント
   */
  onSelect: Consumer<MatterSummary>;
  /**
   * 検索結果リスト
   */
  results: ResultState;
};

type ResultState = {
  results: MatterSummary[];
};

/**
 * 現場選択ダイアログ - 結果アコーディオン
 * @returns
 */
const Result: React.FunctionComponent<ResultProps> = (props) => {
  const { FormDateRange, FormText, form } = useFormItems<ResultState>();
  const { fields } = useFieldArray({ control: form.control, name: 'results' });
  const sizes = useSizeContext();

  React.useEffect(
    () =>
      form.reset({
        results: props.results.results.map((result) => ({
          ...result,
          workDateFrom: Formatter.date(result.workDateFrom),
          workDateTo: Formatter.date(result.workDateTo),
        })),
      }),
    [props.results]
  );

  return (
    <Accordion
      allowToggle
      // as="form"
      // onSubmit={form.handleSubmit((state) => props.onSelect(state.results[0]))}
    >
      {fields.length > 0 ? (
        fields.map((field, idx) => (
          <AccordionItem key={idx}>
            <AccordionButton>
              <Text flex="1" fontWeight="bold" textAlign="left">
                {field.matterName}
              </Text>
              {/* <FormText name={`results.${idx}.matterName`} /> */}
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel as={VStack}>
              <FormText name={`results.${idx}.customerName`} />
              <FormDateRange
                forms={[
                  { name: `results.${idx}.workDateFrom` },
                  { name: `results.${idx}.workDateTo` },
                ]}
                label="作業期間"
                mode="view"
                onClickClear={(name) => form.setValue(name, '')}
              />
              <FormText label="最寄駅" name={`results.${idx}.station`} />
              <FormText label="営業担当" name={`results.${idx}.nameSales`} />
              <FormText
                label="現場担当"
                name={`results.${idx}.customerName`}
              />{' '}
              {/* TODO */}
              <SelectButton
                fontSize={sizes.fontSize.modalButton}
                onClick={() => props.onSelect(props.results.results[idx])}
              />
            </AccordionPanel>
          </AccordionItem>
        ))
      ) : (
        <AccordionItem>結果はありません</AccordionItem>
      )}
    </Accordion>
  );
};

export default Result;
